import { ReactElement, useEffect } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

import { useConnectionContext } from 'contexts/connection';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSeoContext } from 'contexts/seo';
import useAfterLoggedInTarget from 'hooks/useAfterLoggedInTarget';

interface Props {
  loggedInPath: string;
  children: ReactElement;
  metadata: {
    title: MessageDescriptor;
    description: MessageDescriptor;
    img: string;
  };
}

export const LandingFootball = ({
  loggedInPath,
  children,
  metadata,
}: Props) => {
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  const { currentUser } = useCurrentUserContext();
  const { signIn } = useConnectionContext();
  const afterLoggedInTarget = useAfterLoggedInTarget();

  useEffect(
    () =>
      setPageMetadata(formatMessage(metadata.title), {
        img: metadata.img,
        description: formatMessage(metadata.description),
      }),
    [setPageMetadata, formatMessage, metadata]
  );

  useEffect(() => {
    if (!currentUser && afterLoggedInTarget) {
      signIn();
    }
  }, [currentUser, afterLoggedInTarget, signIn]);

  if (currentUser && loggedInPath) {
    return <Navigate to={loggedInPath} replace />;
  }

  return children;
};
